import { SxProp } from '../@types';

export const mergeSx = (baseSx: SxProp, additionalSx?: SxProp): SxProp => {
  return { ...baseSx, ...additionalSx } as SxProp;
};
